// extracted by mini-css-extract-plugin
export default {"header":"Header_header__XZa5K","container":"Header_container__ApXgn","avatar":"Header_avatar__iy9Vv","userProfile":"Header_userProfile__e7d2v"};